import { Grid } from '@material-ui/core';
import React from 'react';

import { saveBloodRelation, updateBloodRelation } from 'api/hs/definitions/health-definitions/blood-relation';
import BaseDefinitionForm from 'Common/BaseDefinitionForm';
import TextField from 'Common/Form/TextField';
import { BloodRelationModel } from 'model/definitions/health-definitions/bloodRelation.model';

interface Props {
  open: boolean;

  /**
   * Fires when the dialog is wanted to be closed
   * @param success `true` when the allergy is created/updated
   */
  onClose(success: boolean): void;

  data: BloodRelationModel;
}

export default function BloodRelation({ open, onClose, data }: Props) {
  return (
    <BaseDefinitionForm<BloodRelationModel>
      open={open}
      onClose={onClose}
      onSave={saveBloodRelation}
      onUpdate={updateBloodRelation}
      data={data}
      resourceReloadName="bloodRelation"
      createTitle="Yakınlık Ekleme"
      updateTitle="Yakınlık Düzenleme"
      maxDialogWidth={500}>
      <Grid item lg={12} md={12}>
        <TextField required name="label" label="Yakınlık Adı Giriniz" />
      </Grid>
    </BaseDefinitionForm>
  );
}
